import React, { useState, useEffect } from "react";
import moment from "moment";
import { convertCurrency, numberFormat } from "../../helper";
import { S3_URL, USER_KEY } from "../../const";
import { useLazyQuery } from "@apollo/client";
import { GET_SHOP } from "../../apollo/shop/Query";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GrCheckboxSelected } from "react-icons/gr";
import { GrCheckbox } from "react-icons/gr";

export default function BillIndebTed({
  cartDatas,
  activeCart,
  selectedPayCurrency,
  gencodeordergroup,
  customername,
  phonenumber,
  userconfirmName,
  userconfirmPhone,
  bankaccount,
  customerLastName,
  village,
  district,
  province,
  notYetPaid,
}) {
  // const now = moment().format("DD/MM/YYYY, h:ss A");
  const index = cartDatas.findIndex((item) => item?.label === activeCart);
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const user = JSON.parse(localStorage.getItem("USER_DATA"));
  const [code, setCode] = useState();

  const currentDateTime = new Date().toLocaleString();


  useEffect(() => {
    setCode(gencodeordergroup);
  }, [gencodeordergroup]);

  return (
    <React.Fragment>
      <div className="purchaseorderlistdetail-A4">
        <div
          style={{ textAlign: "center", fontSize: "28px", marginTop: "20px" }}>
          ໃບບິນເເຈ້ງໜີ້
        </div>
        <div
          style={{
            paddingLeft: "20px",
            display: "flex",
            alignItems: "center",
          }}>
          <div>
            <img
              src={shop?.image ? (S3_URL + shop?.image) : "../../../assets/image/cficon.png"}
              width={100}
            />
          </div>
          <div style={{ paddingLeft: "20px" }}>
            <div>ຮ້ານ :{shop?.name}</div>
            <div>
              {shop?.address?.village},{shop?.address?.district},
              {shop?.address?.province}
            </div>
            <div>ເບີໂທ: {shop?.phone}</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "30px",
          }}>
          <div
            style={{
              width: "50%",
              // textAlign: "ຫະັ",
              paddingLeft: 20,
              borderTop: "1px solid #4d4d4d",
              borderBottom: "1px solid #4d4d4d",
              borderLeft: "1px solid #4d4d4d",
            }}>
            ພະນັກງານຂາຍ :{" "}
            {user?.data?.nickname
              ? user?.data?.nickname
              : user?.data?.firstName + " " + user?.data?.lastName}
            <br />
            ລູກຄ້າ : {customername} {customerLastName}
            <br />
            ທີ່ຢູ່ : {village ? village + "," : ""}{" "}
            {district ? district + "," : ""} {province ?? ""} <br />
            ເບີໂທ :{phonenumber} {userconfirmPhone}
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderTop: "1px solid #4d4d4d",
              borderBottom: "1px solid #4d4d4d",
              borderRight: "1px solid #4d4d4d",
              borderLeft: "1px solid #4d4d4d",
            }}>
            ເລກທີບິນ : {code}
            <br />
            ວັນທີ: {currentDateTime}{" "}
          </div>
        </div>

        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "30px",
          }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50px 350px 50px 100px 130px 70px",
            }}>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                borderTop: "1px solid #4d4d4d",
                borderBottom: "1px solid #4d4d4d",
                borderLeft: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              ລຳດັບ
            </div>
            {/* <div style={{ border: "1px solid #4d4d4d", textAlign: "center" }}>ລະຫັດບາໂຄດ</div> */}
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                borderTop: "1px solid #4d4d4d",
                borderBottom: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              ຊື່ສິນຄ້າ
            </div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                borderTop: "1px solid #4d4d4d",
                borderBottom: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              ຈຳນວນ
            </div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                borderTop: "1px solid #4d4d4d",
                borderBottom: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              ລາຄາ
            </div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                borderTop: "1px solid #4d4d4d",
                borderBottom: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              ລວມລາຄາ
            </div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                borderTop: "1px solid #4d4d4d",
                borderBottom: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              ສະກຸນເງີນ
            </div>
            {cartDatas[index]?.data?.orders?.map((purchaseorder, _index) => (
              <div key={_index}>
                <div 
                  style={{
                    textAlign: "center",
                    borderLeft: "1px solid #4d4d4d",
                    borderRight: "1px solid #4d4d4d",
                    borderBottom: "1px solid #4d4d4d",
                  }}>
                  {_index + 1}
                </div>
                <div
                  style={{
                    textAlign: "start",
                    paddingLeft: "10px",
                    borderRight: "1px solid #4d4d4d",
                    borderBottom: "1px solid #4d4d4d",
                  }}>
                  {purchaseorder?.productName}
                </div>
                <div
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #4d4d4d",
                    borderBottom: "1px solid #4d4d4d",
                  }}>
                  {purchaseorder?.amount}
                </div>
                <div
                  style={{
                    textAlign: "start",
                    paddingLeft: "10px",
                    borderRight: "1px solid #4d4d4d",
                    borderBottom: "1px solid #4d4d4d",
                  }}>
                  {purchaseorder?.price
                    ? numberFormat(purchaseorder?.price)
                    : "-"}
                </div>
                <div
                  style={{
                    textAlign: "start",
                    paddingLeft: "10px",
                    borderRight: "1px solid #4d4d4d",
                    borderBottom: "1px solid #4d4d4d",
                  }}>
                  {numberFormat(purchaseorder?.totalPrice)}
                </div>
                <div
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #4d4d4d",
                    borderBottom: "1px solid #4d4d4d",
                  }}>
                  {convertCurrency(purchaseorder?.currency)}
                </div>
              </div>
            ))}
            <div
              style={{
                width: "400px",
                paddingRight: "10px",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                borderLeft: "1px solid #4d4d4d",
                borderBottom: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              <div>ລວມ :</div>
            </div>
            <div></div>
            <div
              style={{
                width: "350px",
                paddingRight: "10px",
                // fontWeight: "bold",
                paddingLeft: "20px",
                borderBottom: "1px solid #4d4d4d",
                borderRight: "1px solid #4d4d4d",
              }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>ຍອດລວມກີບ</div>
                <div>
                  {" "}
                  {numberFormat(
                    cartDatas[index]?.data?.orderGroup?.totalPrice ?? 0
                  )}{" "}
                  ₭
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>ຍອດລວມບາດ</div>
                <div>
                  {" "}
                  {numberFormat(
                    cartDatas[index]?.data?.orderGroup?.sumPriceBaht ?? 0
                  )}{" "}
                  ฿
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>ຍອດລວມໂດລາ</div>
                <div>
                  {numberFormat(
                    cartDatas[index]?.data?.orderGroup?.sumPriceUsd ?? 0
                  )}{" "}
                  $
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}>
                <div>ລາຄາລວມທັງໝົດ</div>
                <div>
                  {numberFormat(
                    cartDatas[index]?.data?.orderGroup?.sumPrice ?? 0
                  )}
                  &ensp;
                  {convertCurrency(selectedPayCurrency)}
                </div>
              </div>
            </div>
            <div></div>
            <div></div>
            <div></div>

            {/* lyzen */}
          </div>

          <div
            style={{
              display: "flex",
              paddingLeft: "20px",
              paddingRight: "20px",
              marginTop: "50px",
            }}>
            <div style={{ width: "50%", textAlign: "center" }}>
              <div>
                <div>ຜູ້ຂາຍ</div>
                <div style={{ marginTop: "20px" }}>
                  .............................
                </div>
              </div>
            </div>
            <div style={{ width: "50%", textAlign: "center" }}>
              <div>
                <div>ລູກຄ້າເຊັນຮັບເຄື່ອງ</div>
                <div style={{ marginTop: "20px" }}>
                  .............................
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
